module.exports = __webpack_public_path__ + "static/media/info-logo.84a0deb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info-logo.png
// module id = 698
// module chunks = 0